"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'conversation.auto.turn.detection': '自动轮次检测',
    'conversation.auto.turn.detection.help': '检测到静音时自动停止录音',
};
